/*
* @Author: 王春岩 <Bolt>
* @Date:   2017-03-31 16:26:19
* @Last Modified by:   Bolt
* @Last Modified time: 2017-05-16 16:19:37
*/

'use strict';

import jsonp from 'jsonp';
import qs from 'qs';

/**
 * jsonp
 */
function jsonpInstance(url, params, opts) {
    let urlProxy = `//${window._qiwa.sys_global.webSettingsObject.trafficServer}${url}?${qs.stringify(params)}`;
    return new Promise((resolve, reject) => {
        jsonp(urlProxy, opts, (err, data) => {
            if (err) {
                reject(err);
            } else {
                resolve(data);
            }
        });
    });
}

export {
    jsonpInstance
};



// WEBPACK FOOTER //
// ./src/api/from-traffic/_instance.js